import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"min-height":"450px"} }
const _hoisted_2 = {
  key: 1,
  class: "list-group"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { style: {"margin-top":"15px"} }

import { computed, toRef } from 'vue'

    import type { ActiveQuestionReadModel } from '@Evaluation/Estimations/Domain/readmodels'
    import type { DiscreteScaleLevel } from '@Scales/Model'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'HostVoteEditor',
  props: {
    readModel: {}
  },
  emits: ["update-value", "update-comment"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'readModel')

    // ---------------- computed ----------------

    const hasScale = computed(() => (rm.value.ScaleLevels?.length ?? 0) > 0)

    const scaleLevels = computed<DiscreteScaleLevel[]>(() =>
        rm.value.ScaleLevels ?? []
    )

    const value = computed<number | null>({
        get: () => rm.value.GroupVoteValue,
        set: val => emit('update-value', val)
    })

    const comment = computed<string | null>({
        get: () => rm.value.GroupVoteComment,
        set: val => emit('update-comment', val)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!hasScale.value)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "number",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          class: "form-control"
        }, null, 512 /* NEED_PATCH */)), [
          [
            _vModelText,
            value.value,
            void 0,
            { number: true }
          ]
        ])
      : _createCommentVNode("v-if", true),
    (hasScale.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleLevels.value, (sl) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass(["list-group-item list-group-item-action text-center", {'bg-success': value.value === sl.Value, 'bg-white': value.value !== sl.Value}]),
              onClick: ($event: any) => (value.value = sl.Value)
            }, [
              _createElementVNode("strong", null, _toDisplayString(sl.Value) + " - " + _toDisplayString(sl.Name), 1 /* TEXT */),
              (sl.Definition)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(sl.Definition), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 10 /* CLASS, PROPS */, _hoisted_3))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn mt-3", value.value == null ? 'btn-success' : 'btn-outline-secondary']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (value.value = null))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fa-regular", value.value == null ? 'fa-square-check' : 'fa-square'])
        }, null, 2 /* CLASS */),
        _cache[3] || (_cache[3] = _createTextVNode(" Follow the average (default) ", -1 /* CACHED */))
      ], 2 /* CLASS */)
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("textarea", {
        rows: "5",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((comment).value = $event)),
        class: "form-control",
        placeholder: "Comment..."
      }, null, 512 /* NEED_PATCH */), [
        [
          _vModelText,
          comment.value,
          void 0,
          { trim: true }
        ]
      ])
    ])
  ]))
}
}

})